import flow from "lodash/fp/flow";
import getFp from "lodash/fp/get";

export const getMyProfile = getFp(["chat", "profile"]);
export const getMyId = flow(getMyProfile, getFp(["id"]));
